import * as React from "react";
import { SVGProps } from "react";
const Gluten = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 150 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 75C0 33.5786 33.5786 0 75 0V0C116.421 0 150 33.5786 150 75V75C150 116.421 116.421 150 75 150V150C33.5786 150 0 116.421 0 75V75Z"
      fill="#F4F4F1"
    />
    <g clipPath="url(#clip0_6897_82520)">
      <path
        d="M74.4891 32.6305C74.4891 32.6305 68.4506 35.6548 68.3257 41.2452C68.3201 42.0469 68.4724 42.8381 68.774 43.5736C69.0756 44.3091 69.5206 44.9746 70.0834 45.532C71.2202 46.6577 72.7683 47.2748 74.3872 47.2477C76.0061 47.2205 77.5632 46.5513 78.7159 45.3872C79.8687 44.2232 80.5226 42.6596 80.5339 41.0405C80.571 35.7095 74.4891 32.6305 74.4891 32.6305ZM68.9415 51.5517C65.1851 47.8318 58.6367 50.005 58.6367 50.005C58.6367 50.005 56.4424 56.4897 60.2843 60.2941C61.4164 61.4152 62.9582 62.0299 64.5705 62.0028C66.1829 61.9758 67.7336 61.3093 68.8816 60.15C70.0296 58.9907 70.6809 57.4335 70.6921 55.821C70.7034 54.2085 70.0737 52.6728 68.9415 51.5517ZM79.2583 51.3787C83.0675 47.532 89.5871 49.4861 89.5871 49.4861C89.5871 49.4861 91.6915 55.8988 87.7958 59.8329C86.6477 60.9922 85.097 61.6587 83.4847 61.6857C81.8724 61.7128 80.3306 61.0981 79.1984 59.977C78.0663 58.8559 77.4366 57.3202 77.4478 55.7077C77.4591 54.0952 78.1103 52.538 79.2583 51.3787ZM68.9059 69.0048C65.1494 65.285 58.6011 67.4581 58.6011 67.4581C58.6011 67.4581 56.4068 73.9429 60.2486 77.7473C61.3808 78.8684 62.9226 79.4831 64.5349 79.456C66.1472 79.429 67.6979 78.7625 68.846 77.6032C69.994 76.4439 70.6453 74.8867 70.6565 73.2742C70.6677 71.6617 70.038 70.1259 68.9059 69.0048ZM79.2227 68.8319C83.0319 64.9852 89.5515 66.9392 89.5515 66.9392C89.5515 66.9392 91.6559 73.352 87.7601 77.2861C86.6121 78.4454 85.0614 79.1119 83.449 79.1389C81.8367 79.1659 80.2949 78.5513 79.1628 77.4302C78.0306 76.3091 77.4009 74.7734 77.4122 73.1609C77.4234 71.5484 78.0747 69.9912 79.2227 68.8319ZM68.7873 86.0295C65.0308 82.3097 58.4824 84.4828 58.4824 84.4828C58.4824 84.4828 56.2882 90.9676 60.13 94.772C61.2621 95.8931 62.8039 96.5078 64.4163 96.4807C66.0286 96.4537 67.5793 95.7872 68.7273 94.6279C69.8754 93.4686 70.5266 91.9114 70.5379 90.2989C70.5491 88.6864 69.9194 87.1506 68.7873 86.0295ZM79.1041 85.8566C82.9133 82.0099 89.4328 83.9639 89.4328 83.9639C89.4328 83.9639 91.5372 90.3767 87.6415 94.3108C86.4935 95.4701 84.9427 96.1366 83.3304 96.1636C81.7181 96.1907 80.1763 95.576 79.0441 94.4549C77.912 93.3338 77.2823 91.7981 77.2935 90.1856C77.3048 88.5731 77.956 87.0159 79.1041 85.8566Z"
        stroke="currentColor"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.6879 98.3269L73.5692 115.352M82.6367 115.327C82.7146 104.149 94.9803 95.6898 109.51 95.3602C109.421 108.258 98.7997 115.056 82.6367 115.327Z"
        stroke="currentColor"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6897_82520">
        <rect
          width={102}
          height={102}
          fill="white"
          transform="translate(24 24)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default Gluten;
